<template>
  <div class="translate-view">
    <header class="content-heading">
      <h1 class="txt-header">Translations</h1>
    </header>
    <section class="content-main">
    <table class="translate-view__table">
    <thead>
      <tr>
        <th class="narrow-width">#</th>
        <th class="normal-width">Type</th>
        <th class="normal-width">Field</th>
        <th class="large-width lang-cell" v-if="de" :style="langCellWidth">DE</th>
        <th class="large-width lang-cell" v-if="fr" :style="langCellWidth">FR</th>
        <th class="large-width lang-cell" v-if="it" :style="langCellWidth">IT</th>
        <th class="large-width lang-cell" v-if="en" :style="langCellWidth">EN</th>
        <th class="large-width lang-cell" v-if="zh" :style="langCellWidth">ZH</th>
        <th class="large-width lang-cell" v-if="ar" :style="langCellWidth">AR</th>
        <th class="normal-width">from language</th>
        <th class="normal-width">to languages</th>
    </tr>
    </thead>
    <tbody>
      <tr class="text-line" v-if="video.meta.languages !== undefined" v-for="translation in translations" v-bind:key="translation.id" :class="translation.group % 2 ? 'group-even' : 'group-odd'">
          <td class="narrow-width text-cell">{{translation.group}}</td>
          <td class="normal-width text-cell">{{translation.type}}</td>
          <td class="normal-width text-cell">{{translation.field}}</td>
          <td class="large-width lang-cell" v-if="de" :style="langCellWidth">
            <input  name="titleInput" type="text" placeholder="Asset title" v-model="translation.de" />
          </td>
          <td class="large-width lang-cell" v-if="fr" :style="langCellWidth">
            <input name="titleInput" type="text" placeholder="Asset title" v-model="translation.fr" />
          </td>
          <td class="large-width lang-cell" v-if="it" :style="langCellWidth">
            <input name="titleInput" type="text" placeholder="Asset title" v-model="translation.it" />
          </td>
          <td class="large-width lang-cell"  v-if="en" :style="langCellWidth">
            <input name="titleInput" type="text" placeholder="Asset title" v-model="translation.en" />
          </td>
          <td class="large-width lang-cell"  v-if="zh" :style="langCellWidth">
            <input name="titleInput" type="text" placeholder="Asset title" v-model="translation.zh" />
          </td>
          <td class="large-width lang-cell"  v-if="ar" :style="langCellWidth">
            <input name="titleInput" type="text" placeholder="Asset title" v-model="translation.ar" />
          </td>
          <td class="normal-width select-cell">
            <select v-model="translation.sourceLanguage">
              <option disabled value="">Please select one</option>
              <option v-for="language in video.meta.languages" v-bind:key="language">{{language}}</option>
            </select>
          </td>
          <td class="normal-width">
            <label v-for="language in video.meta.languages" v-if="translation.sourceLanguage !== undefined && language !== translation.sourceLanguage" v-bind:key="language"><input type="checkbox" :id="language" :value="language.toUpperCase()" v-model="translation.destLanguages"> {{language}}</label>
            <button v-if="translation.sourceLanguage !== undefined && translation.destLanguages.length > 0" title="Translate" class="button" @click="translateText(translation)"><i class="material-icons">language</i></button>
          </td>
      </tr>
    </tbody>
    </table>
    <div class="translate-view__controls">
      <label for="sourceLanguage">Tranlate Document</label>
      <div class="translate-view__controls-panel">
      <div class="translate-from">
        <label for="sourceLanguage">from</label>
        <select name="sourceLanguage" v-model="sourceLanguage">
          <option disabled value="">Please select one</option>
          <option v-for="language in video.meta.languages" v-bind:key="'source-lang' + language">{{language}}</option>
        </select>
      </div>
      <div class="translate-to">
        <label>to</label>
        <div class="to-language-boxes" >
          <template v-for="language in video.meta.languages" v-if="sourceLanguage !== undefined && language !== sourceLanguage">
            <input type="checkbox" class="regular-checkbox" :id="language"  :key="'dest-lang-' + language"  :value="language.toUpperCase()" v-model="destLanguages" />
            <label class="lang-check" v-bind:key="language">{{language}}</label>
          </template>
        </div>
        <button class="button btn-w-m" :class="{'is-disabled': sourceLanguage === undefined || destLanguages.length === 0}" title="Translate"  @click="translateAllText()">
        Translate
        </button>
      </div>
      </div>
      <!-- Check isDirty :class="{'is-disabled': !isDirty}" -->
         <button title="Save translation" class="save-translation action-button btn-w-m" @click="save()">Save</button>
    </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'translate',
  computed: {
    ...mapGetters(['video', 'selectedAsset']),
     langCellWidth() {
      return {
        "width": `${60 / this.video.meta.languages.length}vw`
      }
    }
  },
  created() {
    const _this = this;
    this.de = this.video.meta.languages.includes('de')
    this.en = this.video.meta.languages.includes('en')
    this.fr = this.video.meta.languages.includes('fr')
    this.it = this.video.meta.languages.includes('it')
    this.zh = this.video.meta.languages.includes('zh')
    this.ar = this.video.meta.languages.includes('ar')

    let groups = {}
    let groupCntr = 0

    this.loadVideoTranslations(this.selectedAsset.id).then((items) => {
        items.map((item) => {
         item.destLanguages = []
         item.de = item.de === undefined && this.de ? '' : item.de
         item.en = item.en === undefined && this.en ? '' : item.en
         item.fr = item.fr === undefined && this.fr ? '' : item.fr
         item.it = item.it === undefined && this.it ? '' : item.it
         item.zh = item.zh === undefined && this.zh ? '' : item.zh
         item.ar = item.ar === undefined && this.ar ? '' : item.ar
         let group = item.id.split("#").slice(0, 2).join("#")
         if (!groups[group]) {
           groups[group] = ++groupCntr
         }
         item.group = groupCntr;
       })
       _this.translations = [...items]
    })
  },
  data: () => ({
    sourceLanguage: undefined,
    translations: [],
    destLanguages: [],
    de: false,
    en: false,
    fr: false,
    it: false,
    zh: false,
    ar: false,
    isDirty: false
  }),
  methods: {
    ...mapMutations(['setVideo']),
    ...mapActions(['loadVideoTranslations', 'saveVideoTranslations', 'translate', 'translateAll']),
    showConfirmation(title, text, cancelLabel, okLabel) {
      const options = {title, cancelLabel, okLabel}
      return this.$dialogs.confirm(text, options)
    },
    save: function() {
      this.saveVideoTranslations({assetId: this.selectedAsset.id, translations: this.translations}).then((video) => {
       this.setVideo(video)
      });
    },
    translateAllText: function() {
      const _this = this;
       this.showConfirmation("Translate", "Do you want to translate all the document? This will override all the textes in the destination languages", "cancel", "tranlate").then(res => {
         if (res.ok) {
            this.translateAll({translations: this.translations, sourceLanguage: this.sourceLanguage, destLanguages: this.destLanguages}).then((items) => {
            _this.translations = [...items]
            this.isDirty = true
          });
         }
       })
    },
    translateText: function(translation) {
      if (translation.destLanguages === undefined) {
        this.video.meta.languages.map((language) => {
          if (language !== translation.lang) {
            translation.destLanguages.push(language)
          }
        })
      }

      this.translate({text: translation[translation.sourceLanguage !== undefined ? translation.sourceLanguage : translation.lang], languages: translation.destLanguages}).then((translations) => {
        translations.map((item) => {
          translation[item.language.toLowerCase()] = item.text;
          this.isDirty = true
        })
      })
    }
  }
}
</script>
